import React from 'react';

export const ColumnFilter = ({ column }) => {
    const { filterValue, setFilter } = column
    return (
        <span className='pt-1 d-block'>
            <input
                className="form-control m-auto"
                style={{width: 'unset'}}
                placeholder='Column Search'
                value={filterValue || ''}
                onChange={(e) => setFilter(e.target.value)}
            />
        </span>
    )
};
